<template>
  <el-card style="margin-bottom: 50px">
    <div class="add-goods-container">
      <!-- <hm-step
        :scroll="true"
        :steps="steps"
        @scroll="windowScroll"
        :step="currentStep"
      ></hm-step> -->
      <el-scrollbar :style="{ height: scrollHeight + 'px' }">
        <div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="product-ruleForm"
          >
            <div id="specification">1.分佣计算设置</div>
            <!-- <el-form-item label="导购推荐成为分销" prop="guiderRecommendMode">
              <el-switch
                v-model="ruleForm.guiderRecommendMode"
                active-text="开启"
                inactive-text="关闭"
                active-color="#13ce66"
                active-value="open"
                inactive-value="close"
              >
              </el-switch>
            </el-form-item> -->
            <el-form-item label="分销模式" prop="commissionMode" v-show="!show">
              <el-radio-group
                :disabled="show"
                v-model="ruleForm.commissionMode"
                @change="changeMode"
              >
                <el-radio label="money">
                  货币返佣
                </el-radio>
                <!-- <el-radio label="point">
                  积分返佣
                </el-radio> -->
              </el-radio-group>
              <span class="form-tip" style="color:red"
                >(注:分佣模式的选择只支持一次选择，首次选择确认后将不可更改，请慎重确认采取何种分销模式。)</span
              >
            </el-form-item>
            <el-form-item
              label="分销会员自购直接获取返佣"
              prop="shareMemberSelfpurchaseMode"
            >
              <el-switch
                v-model="ruleForm.shareMemberSelfpurchaseMode"
                active-text="开启"
                inactive-text="关闭"
                active-color="#13ce66"
                active-value="open"
                inactive-value="close"
              >
              </el-switch>
            </el-form-item>
            <el-form-item
              label="单订单佣金计算"
              prop="singleOrderCommissionCalcMode"
            >
              <el-radio
                v-model="ruleForm.singleOrderCommissionCalcMode"
                label="getGoodsCommission"
                >获取分享物品佣金</el-radio
              >
              <el-radio
                v-model="ruleForm.singleOrderCommissionCalcMode"
                label="getOrderCommission"
                >获取订单总值佣金</el-radio
              >
            </el-form-item>
            <el-form-item
              label="积分货币比"
              prop="perUnitMoneyExchangePointsRatio"
              v-if="ruleForm.commissionMode === 'point'"
            >
              <el-input
                clearable
                size="small"
                v-model="calcModeTwo"
                @blur="blur"
                type="number"
                style="width:170px;"
                @input="filterGt0OrFixed('calcModeTwo')"
                @mousewheel.prevent.native
                maxlength="50"
                placeholder="请输入积分货币比"
              ></el-input>
              比
              <span>1</span>
              <span class="form-tip"
                >(注:积分货币比主要是积分同货币的比例关系，方便产品上架时通过比例设置产品积分返佣数。)</span
              >
              <!-- <el-input
                disabled
                clearable
                size="small"
                v-model="calcModeOne"
                type="number"
                style="width:170px;"
                onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                @mousewheel.prevent.native
                maxlength="50"
                placeholder="请输入积分数"
              ></el-input> -->
            </el-form-item>
            <el-form-item
              label="推荐购买多少天后失效"
              prop="recommendedPurchaseExpiresDays"
            >
              <el-input
                clearable
                size="small"
                v-model="ruleForm.recommendedPurchaseExpiresDays"
                type="number"
                style="width:270px;"
                onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                @input="filterGt0OrFixed0('recommendedPurchaseExpiresDays')"
                @mousewheel.prevent.native
                maxlength="50"
                placeholder="请输入限定时间（天）"
              ></el-input>
              <span class="form-tip"
                >(注:推荐关系发生，且成功引入购物环境中后再设置周期内只要发生购买行为且符合分佣规则，即产生佣金。)</span
              >
            </el-form-item>
            <!-- <el-form-item label="会员自动升级条件" prop="autotagConditionMode">
              <el-select
                clearable
                disabled
                style="width:250px;"
                v-model="ruleForm.autotagConditionMode"
                placeholder="请选择条件关系"
                size="small"
                filterable
                class="mr10"
              >
                <el-option
                  :label="v.itemText"
                  :value="v.itemValue"
                  v-for="(v, i) in autotagList"
                  :key="i"
                ></el-option>
              </el-select>
              <el-input
                clearable
                disabled
                size="small"
                v-model="ruleForm.autotagTotalPurchaseTimeRange"
                type="number"
                onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                @mousewheel.prevent.native
                maxlength="50"
                placeholder="请输入时间周期（限定天数）"
              ></el-input>
              <div>
                <span>单笔购物满&nbsp&nbsp</span>
                <el-input
                  clearable
                  disabled
                  size="small"
                  v-model="ruleForm.autotagSinglePurchaseLowerLimit"
                  type="number"
                  style="width:170px;"
                  onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  @mousewheel.prevent.native
                  maxlength="50"
                  placeholder="请输入单笔消费金额"
                ></el-input>
              </div>
              <div>
                <span>累计消费满&nbsp&nbsp</span>
                <el-input
                  clearable
                  disabled
                  size="small"
                  v-model="ruleForm.autotagTotalPurchaseLowerLimit"
                  type="number"
                  style="width:170px;"
                  onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  @mousewheel.prevent.native
                  maxlength="50"
                  placeholder="请输入累计消费金额"
                ></el-input>
              </div>
              <div>
                <span>推荐会员数&nbsp&nbsp</span>
                <el-input
                  clearable
                  size="small"
                  disabled
                  v-model="ruleForm.autotagShareMemberCountLowerLimit"
                  type="number"
                  style="width:170px;"
                  onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  @mousewheel.prevent.native
                  maxlength="50"
                  placeholder="请输入推荐会员数量"
                ></el-input>
              </div>
            </el-form-item> -->

            <div id="base">2.分销会员身份设置</div>
            <el-form-item label="购买推会员" prop="memberPurchaseSkuName">
              <el-input
                size="small"
                class="mr10 ipt"
                :show-message="showGoodsSn"
                v-model.trim="ruleForm.memberPurchaseSkuName"
                placeholder="绑定商品（商品名称+规格）"
                @click.native="selectGoods"
                readonly
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="返佣" prop="commissionValue">
              <el-input
                clearable
                size="small"
                class="mr10 ipt"
                @input="filterGt0OrFixed4('commissionValue')"
                v-model.trim="ruleForm.commissionValue"
                placeholder="请输入返佣比例"
              ></el-input
              >%
              <span class="form-tip">(注:返佣比例。)</span>
            </el-form-item>

            <div v-if="ruleForm.commissionMode === 'money'">
              <div id="way">3.佣金到账规则设置</div>

              <el-form-item
                label="提现周期设置"
                prop="perMonthAllowGetcashTime"
              >
                <el-input
                  clearable
                  size="small"
                  v-model="ruleForm.perMonthAllowGetcashStartdate"
                  type="number"
                  style="width:200px;"
                  onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  @mousewheel.prevent.native
                  maxlength="50"
                  placeholder="请设置每月提现开始时间"
                ></el-input>
                --
                <el-input
                  clearable
                  size="small"
                  style="width:200px;"
                  v-model="ruleForm.perMonthAllowGetcashEnddate"
                  type="number"
                  onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  @mousewheel.prevent.native
                  maxlength="50"
                  placeholder="请设置每月提现截止时间"
                ></el-input>
                <span class="form-tip">(注:每月提现周期。)</span>
                <!-- <el-date-picker
                :default-time="['00:00:00', '23:59:59']"
                v-model.trim="ruleForm.perMonthAllowGetcashTime"
                type="datetimerange"
                align="right"
                start-placeholder="促销开始时间"
                end-placeholder="促销结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
              ></el-date-picker> -->
              </el-form-item>
              <el-form-item label="满额提现上限" prop="singleGetcashUpperLimit">
                <el-input
                  clearable
                  size="small"
                  v-model="ruleForm.singleGetcashUpperLimit"
                  type="number"
                  style="width:270px;"
                  onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  @mousewheel.prevent.native
                  maxlength="50"
                  placeholder="请输入提现上限额(空则无上限)"
                ></el-input>
              </el-form-item>
              <el-form-item label="满额提现下限" prop="singleGetcashLowerLimit">
                <el-input
                  clearable
                  size="small"
                  v-model="ruleForm.singleGetcashLowerLimit"
                  type="number"
                  style="width:270px;"
                  @input="filterGt0OrFixed4('singleGetcashLowerLimit')"
                  @mousewheel.prevent.native
                  maxlength="50"
                  placeholder="请输入最低提现额(空则为0)"
                ></el-input>
              </el-form-item>
            </div>
            <div class="flex flex-center">
              <el-button
                type="primary"
                size="small"
                @click="submitForm('ruleForm')"
                >提交</el-button
              >
              <el-button size="small" @click="$router.back(-1)">返回</el-button>
            </div>
          </el-form>
        </div>
      </el-scrollbar>
    </div>
    <el-dialog
      title="添加商品"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGoods"
    >
      <div class="table-panel flex  flex-end">
        <div class="flex text-right  flex-end">
          <el-input
            clearable
            style="width:200px;"
            v-model.trim="searchDialogCondition.keyWords"
            placeholder="请输入货号/条码/商品名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-cascader
            v-model="searchDialogCondition.wxshopCategoryId"
            :show-all-levels="false"
            size="small"
            class="mr10"
            :props="categoryFunc"
            clearable
            placeholder="请选择微店商品分类"
          ></el-cascader>
          <el-cascader
            v-model="searchDialogCondition.attributeId"
            placeholder="请选择辅助属性"
            :show-all-levels="false"
            size="small"
            class="mr10"
            :props="attributeFunc"
            clearable
          ></el-cascader>
          <el-input
            clearable
            v-model.trim="searchDialogCondition.minPrice"
            placeholder="最低零售价"
            size="small"
            style="width: 100px"
            class="ipt mr10"
          ></el-input>
          <el-input
            clearable
            v-model.trim="searchDialogCondition.maxPrice"
            placeholder="最高零售价"
            size="small"
            style="width: 100px"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="searchGoods"
            >查询</el-button
          >
          <el-button
            type="info"
            size="small"
            @click="searchDialogCondition = {}"
            >重置</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <div class="tips mb20">提示：点击表格行即可选择</div>
        <el-table
          stripe
          border
          class="mb20"
          ref="brandTable"
          @selection-change="getChecked"
          @current-change="handleCurrentChange"
          highlight-current-row
          :data="wxShopList.records"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentMicroPage - 1) * pageMicroSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="产品名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            show-overflow-tooltip
            label="规格"
          >
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.spuAttributeValueList.join() }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            show-overflow-tooltip
            label="类别"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="价格信息"
          >
            <template slot-scope="scope">
              <div>
                <span>建议零售价：</span>
                <span class="rose">{{ scope.row.wxshopPrice }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="wxShopList.total"
          @current-change="pagingMicro"
          @size-change="handleSizeMicroChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentMicroPage"
        ></el-pagination>
      </div>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="affirm">确认</el-button>
        <el-button size="small" @click="dialogVisibleGoods = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import HmRichEditor from "@/components/HmRichEditor";

import HmStep from "@/components/HmStep";
import { mapGetters } from "vuex";
export default {
  components: { HmRichEditor, HmStep },
  data() {
    const patternTimeFunc = function(rule, val, callback) {
      if (!this.ruleForm.perMonthAllowGetcashStartdate) {
        return callback(new Error("请输入提现开始日期"));
      } else if (!this.ruleForm.perMonthAllowGetcashEnddate) {
        return callback(new Error("请输入提现截止日期"));
      }
      callback();
    }.bind(this);
    const recommendedPurchaseExpiresDaysFunc = function(rule, val, callback) {
      if (val > 99999) {
        return callback(new Error("限制值不得大于99999"));
      }
      callback();
    }.bind(this);
    // const patternCommissionModeFunc = function(rule, val, callback) {
    //   if (val === "money") {
    //     if (!this.ruleForm.moneyValue) {
    //       return callback(new Error("请输入金额"));
    //     } else {
    //       if (this.ruleForm.moneyValue < 0 || this.ruleForm.moneyValue > 1) {
    //         return callback(new Error("请输入大于0小于1之间的数（包括0、1）"));
    //       }
    //     }
    //   } else if (val === "point") {
    //     if (!this.ruleForm.pointValue) {
    //       return callback(new Error("请输入积分"));
    //     } else {
    //       if (this.ruleForm.pointValue < 0 || this.ruleForm.pointValue > 1) {
    //         return callback(new Error("请输入大于0小于1之间的数（包括0、1）"));
    //       }
    //     }
    //   }
    //   callback();
    // }.bind(this);
    // const patternCategoryFunc = function(rule, val, callback) {
    //   if (
    //     !this.ruleForm.autotagConditionMode ||
    //     !this.ruleForm.autotagTotalPurchaseTimeRange ||
    //     !this.ruleForm.autotagSinglePurchaseLowerLimit ||
    //     !this.ruleForm.autotagTotalPurchaseLowerLimit ||
    //     !this.ruleForm.autotagShareMemberCountLowerLimit
    //   ) {
    //     return callback(new Error("请填写所有项"));
    //   }

    //   callback();
    // }.bind(this);
    const patternPointsRatioFunc = function(rule, val, callback) {
      if (!this.calcModeOne || !this.calcModeTwo) {
        return callback(new Error("请填写所有项"));
      }

      callback();
    }.bind(this);
    return {
      // pickerOptions: {
      //   // disabledDate(time) {
      //   //   return time.getTime() < Date.now() - 8.64e7;
      //   // }
      // },
      calcModeOne: 1,
      calcModeTwo: "",
      currentStep: 1,
      scrollHeight: 0,
      currentMicroPage: 1,
      pageMicroSize: 10,
      dialogVisibleGoods: false,
      showGoodsSn: true,
      searchDialogCondition: {},
      checkedRow: [],
      currentRow: {},
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId
              };
            } else {
              params = {
                attributeId: node.data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      show: true,
      ruleForm: {
        guiderRecommendMode: "",
        autotagConditionMode: "",
        autotagTotalPurchaseTimeRange: "",
        autotagSinglePurchaseLowerLimit: "",
        autotagTotalPurchaseLowerLimit: "",
        autotagShareMemberCountLowerLimit: "",
        memberPurchaseSkuName: "",
        shareMemberSelfpurchaseMode: "",
        singleOrderCommissionCalcMode: "",
        perUnitMoneyExchangePointsRatio: "",
        recommendedPurchaseExpiresDays: "",

        singleGetcashUpperLimit: "",
        singleGetcashLowerLimit: "",
        commissionMode: "money",
        commissionValue: "",
        pointValue: "",
        moneyValue: "",
        perMonthAllowGetcashStartdate: "",
        perMonthAllowGetcashEnddate: ""
      },
      rules: {
        guiderRecommendMode: {
          required: true,
          trigger: "change"
        },
        autotagConditionMode: {
          // validator: patternCategoryFunc,
          trigger: "blur"
        },
        memberPurchaseSkuName: {
          required: true,
          message: "请选择购买推会员",
          trigger: "blur"
        },
        shareMemberSelfpurchaseMode: {
          required: true,
          trigger: "change"
        },
        singleOrderCommissionCalcMode: {
          required: true,
          trigger: "change"
        },
        perUnitMoneyExchangePointsRatio: {
          required: true,
          validator: patternPointsRatioFunc,
          trigger: "blur"
        },
        commissionValue: {
          required: true,
          message: "请输入返佣比例",
          trigger: "blur"
        },
        commissionMode: [
          {
            required: true,
            message: "请选择推荐返佣",
            trigger: "blur"
          }
          // {
          //   required: true,
          //   validator: patternCommissionModeFunc,
          //   trigger: "blur"
          // }
        ],
        recommendedPurchaseExpiresDays: [
          {
            required: true,
            message: "请输入限定天数",
            trigger: "blur"
          },
          {
            required: true,
            validator: recommendedPurchaseExpiresDaysFunc,
            trigger: "blur"
          }
        ],
        perMonthAllowGetcashTime: {
          required: true,
          validator: patternTimeFunc,
          trigger: "blur"
        },
        singleGetcashUpperLimit: {
          required: true,
          message: "请输入提现上限额",
          trigger: "blur"
        },
        singleGetcashLowerLimit: {
          required: true,
          message: "请输入最低提现额",
          trigger: "blur"
        }
      },
      steps: [
        {
          name: "分佣计算设置",
          id: "specification"
        },
        {
          name: "分销会员身份设置",
          id: "base"
        },
        {
          name: "佣金到账规则设置",
          id: "way"
        }
      ]
    };
  },
  computed: mapGetters(["autotagList", "detailRules", "wxShopList"]),
  watch: {
    // "ruleForm.commissionMode": {
    //   handler(val) {
    //     if (val === "point") {
    //       this.show = true;
    //     } else if (val === "money") {
    //       this.show = false;
    //     }
    //   },
    //   deep: true
    // }
  },
  created() {},
  mounted() {
    this.$store.dispatch("autotagList");
    this.queryMicroShopGoodsList();
    this.querDetails();
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll, true);
      window.addEventListener("resize", this.handleResize, true);
      this.calcHeight();
    });
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    querDetails() {
      this.$store.dispatch("detailsRule").then(res => {
        if (res.code === "0") {
          if (res.result) {
            this.show = true;
            if (res.result.guiderRecommendMode === "disabled") {
              res.result.guiderRecommendMode = "close";
            } else {
              res.result.guiderRecommendMode = "open";
            }
            if (res.result.shareMemberSelfpurchaseMode === "disabled") {
              res.result.shareMemberSelfpurchaseMode = "close";
            } else {
              res.result.shareMemberSelfpurchaseMode = "open";
            }

            // if (res.result.commissionMode === "money") {
            //   res.result.pointValue = "";
            // } else if (res.result.commissionMode === "point") {
            //   res.result.moneyValue = "";
            // }

            this.calcModeTwo = res.result.perUnitMoneyExchangePointsRatio;

            for (let key in res.result) {
              this.ruleForm[key] = res.result[key];
            }
          } else {
            this.show = false;
          }
        }
      });
    },
    filterGt0OrFixed(prop) {
      this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this[prop] = this[prop].replace(".", "").replace("-", "");
      // this.storeGameTeamRule.storeGameTeamRule[i].prop = this.storeGameTeamRule.storeGameTeamRule[
      //   i
      // ][prop].replace(/[^\d]/g, ""); //仅保留数字
      this[prop] = this[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."

      // //去除其他"."
      // this.storeGameTeamRule.storeGameTeamRule[i][prop] = this.storeGameTeamRule.storeGameTeamRule[
      //   i
      // ][prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      // if (
      //   this.storeGameTeamRule.storeGameTeamRule[i][prop].indexOf(".") < 0 &&
      //   this.storeGameTeamRule.storeGameTeamRule[i][prop] != ""
      // ) {
      //   //首位是0的话去掉
      //   this.storeGameTeamRule.storeGameTeamRule[i][prop] = parseFloat(
      //     this.storeGameTeamRule.storeGameTeamRule[i][prop]
      //   );
      // }
    },
    filterGt0OrFixed4(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    blur() {
      this.$confirm(
        " 调整积分货币比，将导致所有通过比例设置积分返佣的商品所返积分发送变化，请确认是否调整积分货币比?",
        "提示",
        {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning"
        }
      );
    },
    changeMode() {
      this.$confirm(
        "分佣模式的选择只支持一次选择，首次选择确认后将不可更改，请慎重确认采取何种分销模式!!",
        "提示",
        {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning"
        }
      );
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
    selectGoods() {
      this.dialogVisibleGoods = true;
    },
    pagingMicro(page) {
      this.currentMicroPage = page;
      this.queryMicroShopGoodsList();
    },
    handleSizeMicroChange(size) {
      this.currentMicroPage = 1;
      this.pageMicroSize = size;
      this.queryMicroShopGoodsList();
    },
    queryMicroShopGoodsList() {
      let params = {
        pageSize: this.pageMicroSize,
        pageNo: this.currentMicroPage
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );
      searchDialogCondition.wxshopCategoryId = this.isArray(
        searchDialogCondition.wxshopCategoryId
      )
        ? searchDialogCondition.wxshopCategoryId[
            searchDialogCondition.wxshopCategoryId.length - 1
          ]
        : searchDialogCondition.wxshopCategoryId;

      searchDialogCondition.attributeId = this.isArray(
        searchDialogCondition.attributeId
      )
        ? searchDialogCondition.attributeId[
            searchDialogCondition.attributeId.length - 1
          ]
        : "";
      Object.assign(params, searchDialogCondition);
      return this.$store.dispatch("queryWxshopList", params);
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else if (e.target.scrollTop < 100) {
            this.currentStep = 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    affirm() {
      if (this.currentRow) {
        this.dialogVisibleGoods = false;

        let attr = this.currentRow.spuAttributeValueList.join();
        let name = this.currentRow.wxshopSpuName;
        this.ruleForm.memberPurchaseSkuName = `${name}【${attr}】`;
      } else {
        this.$message({
          message: "请选择商品！",
          type: "warning"
        });
      }
    },
    searchGoods() {
      this.currentMicroPage = 1;
      this.queryMicroShopGoodsList();
    },
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          if (this.currentRow.skuId) {
            params.skuId = this.currentRow.skuId;
            params.wxshopSpuId = this.currentRow.wxshopSpuId;
            params.memberPurchaseSkuIds = this.currentRow.wxshopSkuId;
            params.memberPurchaseSpuId = this.currentRow.wxshopSpuId;
          }

          if (params.guiderRecommendMode === "close") {
            params.guiderRecommendMode = "disabled";
          } else {
            params.guiderRecommendMode = "enabled";
          }
          if (params.shareMemberSelfpurchaseMode === "close") {
            params.shareMemberSelfpurchaseMode = "disabled";
          } else {
            params.shareMemberSelfpurchaseMode = "enabled";
          }
          params.perUnitMoneyExchangePointsRatio = this.calcModeTwo;

          this.$store.dispatch("addRule", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.querDetails();
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.add-goods-container {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .step-wrapper {
    border-bottom: 1px solid #ddd;
  }
  .btn {
    margin-left: 10px;
    .hmicon {
      font-size: 12px;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.specification-list {
  li {
    padding: 7px 10px;
    margin: 0;
    color: #666;
    background-color: #f8f8f8;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    margin: 20px 0;
  }
}
</style>
